import { useFormContext, useWatch } from 'react-hook-form';

// Direct path, not the application barrel: this file is inside it, and importing it from itself
// is a cycle (see CasPendingEmailsPill in CasContextProviders).
import SmsImageList from '../SmsImageList';

interface Props {
  // The form field holding the text's pictures, as data: URIs - the email body's, as derived on the
  // way into the SMS view, plus any pasted into the text itself (see SmsTextField).
  name?: string;
}

/*
  The pictures a batch text carries, listed under its text box. The batch's message is one message,
  never edited twice: leaving one off here leaves it out of the emails too, once the SMS content is
  carried back into the email body - so every one of them can be taken off.
*/
export default function BatchSmsPictures({ name = 'smsImages' }: Props) {
  const { control, setValue } = useFormContext();
  const pictures: string[] = useWatch({ control, name }) ?? [];

  return (
    <SmsImageList
      sources={pictures}
      onRemove={(src) =>
        setValue(
          name,
          pictures.filter((image) => image !== src),
          { shouldDirty: true }
        )
      }
    />
  );
}
